import { render, staticRenderFns } from "./MarcasData.vue?vue&type=template&id=a959f240&"
import script from "./MarcasData.vue?vue&type=script&lang=js&"
export * from "./MarcasData.vue?vue&type=script&lang=js&"
import style0 from "./MarcasData.vue?vue&type=style&index=0&id=a959f240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports